/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    '我們已找遍四處，但該網頁似乎不存在，可能已遭到刪除。當然，除非 URL 中有錯字 😉',
  'embedded-confluence-common.src.content.empty-state-header': '我們找不到您要尋找的內容',
  'embedded.confluence.already-logged-in-paragraph': '已經登入了嗎？請嘗試重新整理。',
  'embedded.confluence.footer.hover.text': '在 Confluence 中檢視',
  'embedded.confluence.footer.prefix': '由以下技術支援：',
  'embedded.confluence.generic-error-page.login-to-confluence-button': '登入 Confluence',
  'embedded.confluence.login-page.login-button': '登入 Confluence',
  'embedded.confluence.login-page.login-button.aria-label': '登入按鈕',
  'embedded.confluence.login-page.login-text': '您需要登入才能檢視此頁面',
  'embedded.confluence.login-page.refresh-page-banner':
    '登入後，此頁面應該會自動重新整理。如果沒有，您可以按一下這裡進行重新整理',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': '重新整理頁面',
  'embedded.confluence.need-to-log-in-paragraph': '您需要登入才能檢視此頁面',
  'embedded.confluence.still-having-trouble-paragraph': '仍然有問題嗎？請確定您已啟用第三方 Cookie，或{link}',
  'embedded.confluence.troubleshooting-link-text': '參閱此疑難排解指南。',
  'embedded.confluence.troubleshooting-link.aria-label': '疑難排解指南連結',
};
